'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLaptop, iconLaptopTag } from '@ni/nimble-components/dist/esm/icons/laptop';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLaptop };
export { iconLaptopTag };
export const NimbleIconLaptop = wrap(IconLaptop);